module.exports = __webpack_public_path__ + "img/averageMoneyCommission.c8dee654.svg";